<div [formGroup]="parentFormReceipt">
  <div formGroupName="receiptSettings">
    <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
      <div fxFlex="100">
        <mat-card>
          <mat-card-header>
            <mat-card-title>
              {{ "module-assignment.receipt_settings.title" | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
              <div fxFlex="100" fxFlex.gt-sm="10" fxLayoutAlign="start center">
                {{ "module-assignment.receipt_settings.print" | translate }}
              </div>
              <div fxFlex="100" fxFlex.gt-sm="10">
                <mat-slide-toggle id="print" formControlName="print"> </mat-slide-toggle>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
              <div fxFlex="100" fxFlex.gt-sm="10" fxLayoutAlign="start center">
                {{ "module-assignment.receipt_settings.email" | translate }}
              </div>
              <div fxFlex="100" fxFlex.gt-sm="10">
                <mat-slide-toggle id="email" formControlName="email"> </mat-slide-toggle>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
              <div fxFlex="100" fxFlex.gt-sm="10" fxLayoutAlign="start center">
                {{ "module-assignment.receipt_settings.giftcard" | translate }}
              </div>
              <div fxFlex="100" fxFlex.gt-sm="10">
                <mat-slide-toggle id="giftcard" formControlName="giftcard"> </mat-slide-toggle>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
              <div fxFlex="100" fxFlex.gt-sm="10" fxLayoutAlign="start center">
                {{ "module-assignment.receipt_settings.wechat" | translate }}
              </div>
              <div fxFlex="100" fxFlex.gt-sm="10">
                <mat-slide-toggle id="wechat" formControlName="wechat"> </mat-slide-toggle>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
